// extracted by mini-css-extract-plugin
module.exports = {"spacer-15":"spacer_spacer-15__zQ_3R","spacer-30":"spacer_spacer-30__lZAh9","spacer-45":"spacer_spacer-45__womrY","spacer-60":"spacer_spacer-60__QUpiP"};